
import DetailCampusDiplomasList from '~/components/DetailCampusDiplomasList.vue';


export default {
    head() {
        return {
            title: this.detailInfo?.attributes?.metaTitle ? `${this.detailInfo?.attributes?.metaTitle}` : `${this.campusInfo?.attributes?.name}`,
            meta: this.detailInfo?.attributes?.meta != null && this.detailInfo?.attributes?.meta != undefined ?
                JSON.parse(this.detailInfo?.attributes?.meta.replace('\n', '')) : null
            
        };
    },
    data() {
        const strapiBaseUri = process.env.strapiBaseUri;
    },
    mounted() {
        setTimeout(() => {
            if (this.$refs.videobackground) {
                this.$refs.videobackground.player.play();
            }
        }, 3000);

        if (process.browser) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('inView');
                    }
                });
            }, {
                threshold: 0
            });

            [...document.querySelectorAll('.animatable')].map(animatable => {
                observer.observe(animatable);
            })

        }
    },
    methods: {
        styleDiplomaButonGrad(offreAlternance) {
            let r, g, b;
            r = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(0, 3);
            g = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(3, 6);
            b = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(6, 9);
            return {
                '--text-color': '#aaaaaa',
                '--text-color1r': Number(r) + 10,
                '--text-color1g': Number(g) - 55,
                '--text-color1b': Number(b) + 30,
                '--text-color2r': Number(r) + 10,
                '--text-color2g': Number(g) + 10,
                '--text-color2b': Number(b) + 25,
                '--text-color3r': Number(r) + 40,
                '--text-color3g': Number(g) - 50,
                '--text-color3b': Number(b) - 50,
                '--text-color4r': Number(r) - 30,
                '--text-color4g': Number(g) + 30,
                '--text-color4b': Number(b) + 55
            };
        },
    },
    async asyncData({ params, $http, store, redirect }) {
        // let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
        // instances = instances.data;
        let instances = store.state.instances;

        const instance = instances.filter((instance) => {
            return instance.attributes.subFolderName == params.campusHP;
        })[0];

        if(!instance){
            // redirect to lost page
            redirect('/404-error/')
        }

        let campusInfo = store.state.campusInfo;
        // let campusInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-home-page?populate=
        // banniere,banniereLogo,avantageCampusLogo1,avantageCampusLogo2,avantageCampusLogo3,tousNosCentresImage,videoDeFond`);
        // campusInfo = campusInfo.data;
        let banniereUrl = process.env.strapiBaseUri + campusInfo.attributes.banniere?.data?.attributes?.url;
        let banniereLogoUrl = process.env.strapiBaseUri + campusInfo.attributes.banniereLogo?.data?.attributes?.url;
        let avantageCampusLogo1Url = process.env.strapiBaseUri + campusInfo.attributes.avantageCampusLogo1?.data?.attributes?.url;
        let avantageCampusLogo2Url = process.env.strapiBaseUri + campusInfo.attributes.avantageCampusLogo2?.data?.attributes?.url;
        let avantageCampusLogo3Url = process.env.strapiBaseUri + campusInfo.attributes.avantageCampusLogo3?.data?.attributes?.url;
        let videoDeFondUrl = process.env.strapiBaseUri + campusInfo.attributes.videoDeFond?.data?.attributes?.url;

        // let campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-diplomas`);
        // campusDiplomas = campusDiplomas.data;
        let campusDiplomas = JSON.parse(JSON.stringify(store.state.campusDiplomas));

        const diplomaInfo = campusDiplomas.filter((diploma) => {
            return diploma.attributes.acronyme == params.diploma;
        })[0];
        let collone1Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_1';
        });
        collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre;
        });
        let collone2Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_2';
        });
        collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre;
        });
        let collone3Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_3';
        });
        collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre;
        });

        let detailInfo = store.state.detailInfo;
        // let detailInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-detail-home-page?populate=
        // image1CampusAvantage,image2CampusAvantage,imageCarte1,imageCarte2,imageCarte3,imageCarte4`);
        // detailInfo = detailInfo.data;
        let imageCarte1Url = process.env.strapiBaseUri + detailInfo.attributes.imageCarte1?.data?.attributes?.url;
        let imageCarte2Url = process.env.strapiBaseUri + detailInfo.attributes.imageCarte2?.data?.attributes?.url;
        let imageCarte3Url = process.env.strapiBaseUri + detailInfo.attributes.imageCarte3?.data?.attributes?.url;
        let imageCarte4Url = process.env.strapiBaseUri + detailInfo.attributes.imageCarte4?.data?.attributes?.url;
        let image1CampusAvantageUrl = process.env.strapiBaseUri + detailInfo.attributes.image1CampusAvantage?.data?.attributes?.url;
        let image2CampusAvantageUrl = process.env.strapiBaseUri + detailInfo.attributes.image2CampusAvantage?.data?.attributes?.url;

        let newsGenerales = await $http.$get(`${process.env.strapiBaseUri}/api/news-generales?populate=imageGenerale,imageCarrousel,campus`);
        newsGenerales = newsGenerales.data;

        const filterednewsGenerales = newsGenerales.filter((newsGenerale) => {
            return newsGenerale?.attributes?.campus?.data?.id == instance.id
        });

        let yourDate = new Date();
        yourDate = yourDate.toISOString().split('T')[0];

        let jposInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-jpos?filters[dateJPO][$gte]=${yourDate}&filters[dateDebutAff][$lte]=${yourDate}`);
        jposInfo = jposInfo.data;
        return {
            instances, instance, campusInfo, jposInfo,
            campusDiplomas, collone1Diplomas, collone2Diplomas, collone3Diplomas,
            banniereUrl, banniereLogoUrl, videoDeFondUrl,
            avantageCampusLogo1Url, avantageCampusLogo2Url, avantageCampusLogo3Url,
            detailInfo, imageCarte1Url, imageCarte2Url, imageCarte3Url, imageCarte4Url,
            image1CampusAvantageUrl, image2CampusAvantageUrl, newsGenerales, filterednewsGenerales
        };
    },
    components: { DetailCampusDiplomasList }
}
